import type { TreatmentItem } from "@/pages/treatments/data";

export default function TreatmentCard({ item }: { item: TreatmentItem }) {
  return (
    <article className="group bg-[#f4f8f5] rounded-lg border border-brand-100 hover:border-brand-300 transition p-5 md:p-6 flex items-start gap-4">
      <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-white border border-brand-100 text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition">
        <i className="ri-sparkling-2-line text-lg"></i>
      </div>
      <div className="min-w-0">
        <h3 className="text-base md:text-lg font-semibold text-brand-800 leading-snug">{item.name}</h3>
        <div className="mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-brand-100/70 text-brand-700 text-xs">
          <i className="ri-focus-3-line"></i>
          <span>針對：{item.problem}</span>
        </div>
      </div>
    </article>
  );
}